module.exports = __webpack_public_path__ + "static/media/asb_sur_typ_3.927974ce.png";